import { AnimatedSwitcher, type AnimatedSwitcherProps } from './AnimatedSwitcher';
import styles from './AnimatedSwitcher.module.css';

/**
 * Перенос `lib/src/presentation/widgets/ignore_animated_switcher.dart`.
 *
 * В Dart это тот же `AnimatedSwitcher` со своим `layoutBuilder`: стопка по
 * центру, а уходящие дети завёрнуты в `IgnorePointer`. Разметка стопки
 * и так центрирует детей, поэтому остаётся только погасить у них нажатия —
 * это делает класс из общего CSS-модуля свитчера.
 */
export type IgnoreAnimatedSwitcherProps = AnimatedSwitcherProps;

export function IgnoreAnimatedSwitcher({
  className,
  ...rest
}: IgnoreAnimatedSwitcherProps) {
  return (
    <AnimatedSwitcher
      {...rest}
      className={`${styles.ignorePointerPrevious} ${className ?? ''}`}
    />
  );
}
